import { render, staticRenderFns } from "./FormAddParticipant.vue?vue&type=template&id=1f2f44f4&"
import script from "./FormAddParticipant.vue?vue&type=script&lang=js&"
export * from "./FormAddParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports